import { BrowserRouter as Router, Route } from 'react-router-dom';
import React, { useState, Component } from 'react';
import { isEmpty, init } from 'ramda';
import firebase from 'firebase';
import 'firebase/auth';

import AppContext, { initialState } from '../src/context/AppContext';

import Dashboard from './views/Dashboard'
import Login from './views/Login'
import Register from './views/Register'
import PrivateRoute from './components/PrivateRoute';

class App extends Component {
  constructor(props) {
    super(props);
    
    this.state = initialState;
  }

  componentDidMount() {
    this.listener = firebase.auth().onAuthStateChanged(user => {
      const currentUser = user || null;

      this.setState({ user: currentUser }, () => this.setState({ loading: false }));
    });
  }

  componentWillUnmount() {
    this.listener();
  }

  render() {
    if(this.state.loading) {
      return (
        <div class='site-container--center'><div class="lds-ring lds-ring--start"><div></div><div></div><div></div><div></div></div></div>
      )
    }

    return (
      <AppContext.Provider value={this.state}>
        <Router>
          <Route path='/login' component={Login} />
          <Route path='/register' component={Register} />
          <PrivateRoute path='/dashboard' component={Dashboard} />
        </Router>
      </AppContext.Provider>
    )
  }
}

export default App;
